import { render, staticRenderFns } from "./ParentRequestView.vue?vue&type=template&id=5ac490a2"
import script from "./ParentRequestView.vue?vue&type=script&lang=js"
export * from "./ParentRequestView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports